<template>
  <textarea :name="name" class="form-control" :value="value" v-on="inputListeners" ref="textarea"></textarea>
</template>

<script>
export default {
  name: 'BaseTextarea',
  props: {
    value: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.setTextareaHeight()
  },
  computed: {
    inputListeners() {
      let vm = this

      return Object.assign({}, this.$listeners, {
        input: function(event) {
          vm.$emit('input', event.target.value)
        }
      })
    }
  },
  methods: {
    setTextareaHeight() {
      if (!this.$refs.textarea) {
        return
      }
      if (this.$refs.textarea.offsetHeight >= this.$refs.textarea.scrollHeight) {
        return
      }
      this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight + 'px'
    }
  }
}
</script>
